import { Component } from '@angular/core';
import { GridShapeComponent } from '../../../shared/components/common/grid-shape/grid-shape.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-accessible',
  imports: [
    GridShapeComponent,
    RouterModule,
  ],
  templateUrl: './not-accessible.component.html',
  styles: ``
})
export class NotAccessibleComponent {

  currentYear: number = new Date().getFullYear();
}
